const USERWAY_WIDGET_URL = "https://cdn.userway.org/widget.js";

export const initializeUserWay = accountId => {
  if (!accountId || document.querySelector(`script[src="${USERWAY_WIDGET_URL}"]`)) {
    return;
  }

  const script = document.createElement("script");
  script.src = USERWAY_WIDGET_URL;
  script.dataset.account = accountId;
  script.async = true;
  script.defer = true;

  document.body.appendChild(script);
};
